<template>
  <div class="main-hero">
    <b-container>
      <b-row class="flex-column-reverse flex-md-row">
        <b-col
          lg="7"
          md="7"
          class="coming-soon__text"
          style="padding-bottom: 10px;"
        >
          <span class="single">
            Join HeartBeatFam as we redefine dementia care for families like yours
</span>
          <hr />
          <h4 style="color:black">
           Enter your email and we will contact you:
          </h4>
          <div class="input-email">
            <div>
              <input
                type="email"
                v-model="email"
                class="form-control"
                placeholder="Enter Email For Early Access"
              />
              <span class="error">{{ error }}</span>
            </div>
            <button
              class="btn btn-success"
              style="border: none;"
              @click="getEarlyAccess"
            >
              Join
            </button>
          </div>
          <social-media />
        </b-col>
        <b-col lg="5" md="5" class="banner-img">
          <b-img
              thumbnail
              fluid src="@/assets/img/betaSignUp/img.png"
               lt="Holding Hands"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SocialMedia from "@/components/home/SocialMedia";
//import { getAnalytics, logEvent } from "firebase/analytics";
export default {
  name: "Home_Main_Row",
  created(){

  },
  components: {
    SocialMedia
  },
  methods: {
    getEarlyAccess() {
      this.error = "";
      if (!this.validateEmail(this.email)) {
        //logEvent(this.analytics, 'signup_beta_error');

        this.error = "Please Enter a valid email!";
        return;
      }
      this.$emit("applied", this.email);
      this.email = "";
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  },
  data() {
    //const analytics = getAnalytics();
    return {
      email: "",
      error: ""
    };
  },
};
</script>

<style lang="scss" scoped>
.single {
  max-width: 600px;
  width: 100%;
  // height: 134px;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 45px;
  line-height: 120%;
  /* or 67px */

  /* Body */

  color: #222222;
}
.coming-soon__text {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.main-hero {
  //background: url("../../assets/img/home/hero.svg") no-repeat center center;
  //background-size: cover;
  background-color: #ffc728;
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 55px;
    color: #0d0d21;
    display: flex;
    column-gap: 15px;
    margin-bottom: 16px;
    span {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 27px;
      display: flex;
      align-items: center;
      color: #ffcc4d;
      margin-top: -5px;
    }
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #f3f6f9;
    margin-bottom: 30px;
  }
  .input-email {
    display: flex;
    justify-content: center;
    column-gap: 8px;
    min-height: 50px;
    & > div {
      width: 100%;
    }
    .error {
      display: inline-block;
      margin-bottom: 6px;
      font-size: 12px;
      margin-left: 10px;
      color: #fff;
    }
    .form-control {
      padding: 12px 27px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #fff;
      &:focus {
        outline: none;
        border: 1px solid #fff;
      }
      &::-webkit-input-placeholder {
        /* Edge */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      ::placeholder {
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
    .btn-success {
      background: #010610;
      border-radius: 32px;
      height: 40px;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      padding: 12px 16px;
      min-width: 150px;
      &:after,
      &:before {
        content: none;
      }
    }
  }
  img {
    margin: 40px 0;
  }
}
@media (min-width: 992px) {
  .banner-img {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 25px;
  }
}
@media (max-width: 768px) {
  .coming-soon__text {
    margin-top: 24px;
  }
  .main-hero {
    padding: 44px 0;
    h3 {
      font-size: 24px;
    }
    .input-email {
      display: grid;
      grid-template-columns: 1fr;
      justify-items: start;
      margin-bottom: 12px;
    }
    .single {
      display: contents;
      height: unset;
    }
  }
  .banner-img svg {
    height: 400px;
  }
}
@media (max-width: 640px) {
  .single {
    font-size: 32px;
  }
}
</style>
